<template>
  <div>
    <HomeHeader />
    <div style="padding-top: 70px;width: 100%;">
      <el-container >
        <el-main style="padding: 20px 0;display: flex;margin: 0 12%">
          <div style="height: 100%;width: 14%;margin-right: 1%;background-color: #FFFFFF;text-align: center;">
            <el-button style="font-size: 16px;margin: 17px 0;background-color: #4D78FF" type="primary" round @click="goPage('/forum/edit')"><i class="el-icon-s-promotion" style="font-size: 20px"></i>发帖子</el-button>
            <el-menu
                :default-active="channelIds[0] || '0'"
                text-color="#999999"
                active-text-color="#000"
                style="text-align: center;font-size: 14px;padding: 15px 0">
              <el-menu-item :index="0" @click="chooseMenu(0)">
                <span slot="title">全部频道</span>
              </el-menu-item>
              <el-menu-item v-for="(item, index) in channelList" v-show="item.status == 1" :key="'channel' + index" :index="item.id" @click="chooseMenu(item.id)">
                <span slot="title">{{item.name}}</span>
              </el-menu-item>
            </el-menu>
          </div>
          <div style="width: 85%;background-color: #FFFFFF">
            <!-- 轮播图 -->
            <div class="banner">
              <el-carousel interval="4000">
                <el-carousel-item v-for="(item, idx) in bannerList" :key="item.contentId">
                  <span v-if="item.link" style="cursor:pointer;" @click="openLocation(`${getLink(item.link)}`, idx, 'home_banner_')">
                    <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="Banner" width="100%" height="100%"/>
                  </span>
                  <img v-else :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="Banner" width="100%" height="100%" @click="goBannerDetail(item.contentId, idx, 'home_banner_')"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div ref="top" style="margin-top: 10px;width: 100%;padding-left:35px;padding-top: 10px;box-sizing: border-box;display: flex;justify-content: space-between">
              <div style="min-width: 320px">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="最新推荐" name="1"></el-tab-pane>
                  <el-tab-pane label="回复最多" name="2"></el-tab-pane>
                  <el-tab-pane label="点赞最多" name="3"></el-tab-pane>
                </el-tabs>
              </div>
              <div style="min-width: 350px;margin-right: 10px">
                <el-input v-model="keyword" style="width: 270px;" prefix-icon="el-icon-search" @keyup.enter.native="toSearch()"></el-input>
                <el-button type="primary" style="width: 70px;margin-left: 10px" @click="toSearch()">搜索</el-button>
              </div>
            </div>
            <div v-show="list.length > 0" style="width: 100%">
              <div
                  v-for="(item, index) in list"
                  :key="'list' + index"
                  style="border-bottom: 1px solid #DDDDDD;min-height: 129px;padding: 20px 28px;box-sizing: border-box" >
                <div style="height: 50%;display: flex;align-items: center">
                  <img v-if="item.top === 1" src="@/assets/img/forum/forum_top.png" style="width: 24px;height: 24px;margin-right: 7px" alt="">
                  <div >
                    <a class="forum_title" :href="hrefUrl+'/forum/detail?id='+item.id" >{{item.title}}</a>
                    <!-- 学堂、论坛的分组标签全部隐掉 -->
                    <!-- <div class="tab1">{{showChannel(item.channelIds[0])}}</div> -->
<!--                    <div style="display: inline-block">-->
                    <div v-for="(tagItem, tagIndex) in item.tags" :key="'tag' + tagIndex" class="tab">{{tagItem}}</div>
<!--                    </div>-->
                  </div>
                </div>
                <!-- <div style="display: flex;margin: 10px 0;">
                  <img v-for="(imgItem, imgIndex) in item.img" :key="'img' + imgIndex" :src="imgItem + '?imageMogr2/quality/60'" style="height: 100px;margin: 0 10px;">
                </div> -->
                <div style="height: 50%;padding-top: 15px;box-sizing: border-box;display: flex;align-items: center;justify-content: space-between">
                  <div style="width: 600px;display: flex;align-items: center">
                    <img v-if="!item.headPortrait || item.headPortrait === ''" src="@/assets/img/forum/forum_user.png" style="width: 26px;height: 26px;margin-right: 12px;border-radius: 50%" alt="">
                    <img v-else :src="item.headPortrait + '?imageMogr2/quality/60'" style="width: 26px;height: 26px;margin-right: 12px;border-radius: 50%" alt="">
                    <div slot="reference" :ref='`bt${index}`' class="forum_author" @click='clickPop(index, item)'>
                      <div class="forum_author_text">
                        {{ item.author }}
                      </div>
                      <div class="flag_icon_container" v-show="Number(item.adminRole) === 1">
                        <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
                      </div>
                    </div>
                    <div class="forum_time">{{timeFormatSeconds(item.publishTime)}}</div>
                  </div>
                  <div style="width: 250px;display: flex;align-items: center;font-size: 14px;justify-content: space-between">
                    <div style="align-items: center;display: flex">
                      <i class="el-icon-view" style="color: #2F374B;font-size: 24px;margin-right: 2px"></i>
                      <span style="line-height: 1">{{item.views}}</span>
                    </div>
                    <div style="align-items: center;display: flex">
                      <img src="@/assets/icons/like.svg" style="width: 24px;height: 24px;margin-right: 2px" alt="">
                      <span style="line-height: 1">{{item.thumbs}}</span>
                    </div>
                    <div style="align-items: center;display: flex">
                      <i class="el-icon-chat-dot-round" style="color: #2F374B;font-size: 24px;margin-right: 2px"></i>
                      <span style="line-height: 1">{{item.comment}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="list.length < 1" style="width: 100%;text-align: center;padding: 20px;box-sizing: border-box">
              <img src="@/assets/img/pages/nodata.png" style="height: 250px;" alt="">
            </div>
            <div class="pagination">
              <el-pagination
                  background
                  :current-page.sync="currentPage"
                  :page-size="pageSize"
                  layout="prev, pager, next, total, jumper"
                  :total="total"
                  @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <el-popover
      v-if='showPop'
      ref='pop'
      :reference='reference'
      placement="top"
      trigger="click"
      width="700"
      >
      <div class="popover_body">
        <div class="popover_head">
          <img v-if="!commentPop.header || commentPop.header === ''" src="@/assets/img/forum/forum_user.png" alt="">
          <img v-else :src="commentPop.header + '?imageMogr2/quality/60'" alt="">
          <div class="popover_message">
            <div>
              <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:160px" :title="commentPop.name">
                {{commentPop.name}}
              </div>
              <div class="flag_icon_container" v-show="Number(commentPop.adminRole) === 1">
                <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
              </div>
              <div class="popover_tab">LV{{!commentPop.level || commentPop.level === '0' ? '1' : commentPop.level}} {{commentPop.levelName}}</div>
            </div>
            <div style="color: #999999;font-size: 14px;padding-top: 14px;justify-content: flex-start">
              <div style="width:120px">{{commentPop.levelRumenOrZhuanye === '0' ? ' 产品原型设计' : '车载应用开发'}}</div>
              <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:270px" :title="commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce">个人介绍：{{commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce}}</div>
            </div>
          </div>
        </div>
        <div class="popover_foot">
          <div>已发布的应用数：{{commentPop.appSum}}</div>
          <div>已发布的场景数：{{commentPop.sceneSum}}</div>
          <div>经验值：{{commentPop.exp}}</div>
          <div>性别： {{commentPop.gender === '' || commentPop.gender === null || commentPop.gender === '0' ? '未公开' : (commentPop.gender === '1' ? '男' : '女')}}</div>
          <div>生日： {{!commentPop.birthDay || commentPop.birthDay === null || commentPop.birthDay === '' ? '未公开' : commentPop.birthDay}}</div>
        </div>
      </div>
    </el-popover>
    <HomeFooter style="margin-top:0;position: relative;bottom: 0"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { findPage, channelFind, getBannerURL, selectPersonalInfo } from '@/api/modules/forum'
import { getInformationList } from '@/api/modules/Information'
import { getMilliData1 } from '@/scripts/dataTimeUtils'
export default {
  name: 'ForumList',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      total: '',
      activeName: '1',
      currentPage: 1,
      pageSize: 10,
      keyword: '',
      status: '2',
      list: [],
      channelList: [],
      channelIds: [],
      bannerImageView: '',
      commentPop: {},
      // 控制渲染条件 如果不用v-if会报错 具体可自行尝试
      showPop: false,
      // 保存当前激活的refrence id
      activeId: '',
      bannerList: [],
      hrefUrl: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.currentPage = Number(route.query['page']) || 1
        this.activeName = route.query['tab'] || '1'
        const channelId = route.query['channel'] || ''
        if (channelId) {
          this.channelIds = [channelId]
        }
        this.findPage()
      }
    }
  },
  created() {
    this.currentPage = Number(this.$route.query['page']) || 1
    this.activeName = this.$route.query['tab'] || '1'
    const channelId = this.$route.query['channel'] || ''
    if (channelId) {
      this.channelIds = [channelId]
    }
    this.findPage()
    this.channelFind()
    // this.getBannerURL()
    this.getTopBannerList()
  },
  methods: {
    async getBannerURL() {
      const data = { id: '1050502238550343680' }
      const res = await getBannerURL(data)
      if (res.code === 0) {
        this.bannerImageView = res.data.cosPath
      }
    },
    showChannel(id) {
      if (!id) {
        return '删除的频道'
      }
      const data = this.channelList.filter((channel) => {
        return channel.id === id
      })
      if (data) {
        return data[0].name
      }
      else {
        return '删除的频道'
      }
    },
    toDetail(id) {
      this.$router.push({ path: '/forum/detail', query: { id: id }})
    },
    async channelFind() {
      const data = {}
      const res = await channelFind(data)
      if (res.code === 0) {
        this.channelList = res.data
      }
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.currentPage = 1
      this.$router.push({ query: { page: this.currentPage, channel: this.channelIds[0], tab: this.activeName }})
      this.findPage()
    },
    async findPage() {
      const data = {
        status: this.status,
        ascOrDesc: 'DESC',
        channelIds: this.channelIds
      }
      if (this.activeName === '2') {
        data.orderBy = 'comment'
      }
      else if (this.activeName === '3') {
        data.orderBy = 'thumbs'
      }
      else {
        data.orderBy = 'publishTime'
      }
      const res = await findPage(data, this.currentPage, this.pageSize)
      if (res.code === 0) {
        this.total = res.total
        this.list = res.data
      }
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    toSearch() {
      if (this.isNull(this.keyword)) {
        this.currentPage = 1
        this.findPage()
      }
      else {
        this.$router.push(
          { path: '/forum/search', query: { keyword: this.keyword }}
        )
      }
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hours = d.getHours()
      var min = d.getMinutes()
      var seconds = d.getSeconds()

      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      if (hours < 0) hours = '0' + hours
      if (min < 10) min = '0' + min
      if (seconds < 10) seconds = '0' + seconds

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds)
    },
    goPage(page) {
      if (this.getCookie('userid')) {
        this.$router.push(page)
        return
      }
      this.$router.push('/login')
    },
    chooseMenu(id) {
      this.channelIds = []
      if (id !== 0) {
        this.channelIds.push(id)
      }
      this.currentPage = 1
      this.$router.push({ query: { page: this.currentPage, channel: this.channelIds[0] }})
      this.findPage()
    },
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    handleCurrentChange() {
      this.$router.push({ query: { page: this.currentPage, channel: this.channelIds[0], tab: this.activeName }})
      this.findPage()
      setTimeout(() => {
        this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' })
      }, 300)
    },
    async clickPop(item, row) {
      // 这个操作是为了避免与源码中的点击reference doToggle方法冲突
      if (this.activeId === item && this.showPop) return
      const data = {
        userId: row.authorId
      }
      const res = await selectPersonalInfo(data)
      if (res.code === 0) {
        this.commentPop = res.data
        this.commentPop.name = row.author
        this.commentPop.header = row.headPortrait
      }
      this.showPop = false
      this.activeId = item
      // 因为reference是需要获取dom的引用 所以需要是$el
      this.reference = this.$refs['bt' + item][0]
      this.$nextTick(() => {
        // 等待显示的popover销毁后再 重新渲染新的popover
        this.showPop = true
        this.$nextTick(() => {
          // 此时才能获取refs引用
          this.$refs.pop.doShow()
        })
      })
    },
    // 时间转换
    gainDataTime(value) {
      return getMilliData1(value)
    },
    async getTopBannerList() {
      const bannerObj = {
        groupId: '21821'
      }
      const bannerRes = await getInformationList(bannerObj)
      if (bannerRes.code === 0) {
        this.bannerList = bannerRes.data.dataList
      }
      else {
        this.$message({
          message: bannerRes.msg,
          type: 'error'
        })
        return
      }
    },
    goBannerDetail(id, idx, evtPrefix) {
      this.$mta.up({ ac: `${evtPrefix}${idx + 1}` })
      setTimeout(() => {
        this.$router.push({
          name: 'ContentDetail',
          query: {
            id: id
          }
        })
      }, 300)
    },
    openLocation(link, idx, evtPrefix) {
      this.$mta.up({ ac: `${evtPrefix}${idx + 1}` })
      setTimeout(() => {
        location.href = link
      }, 300)
    },
    getLink(link) { // 处理http link
      return link.indexOf('http') === 0 ? link : `https://${link}`
    }
  }
}
</script>

<style scoped>
/deep/ .el-menu-item.is-active{
  background-color: #F3F3F3;
  color: #2F374B;
}
/deep/.el-menu-item:hover{
  background-color: #F3F3F3;
}
/deep/.el-tabs__active-bar{
  width: 16px !important;
  height: 4px !important;
  border-radius: 3px;
  background: #4d78ff;
  margin-left: 20px;
}
/deep/.el-tabs__nav-wrap::after{
  display: none;
}
/deep/.el-tabs__item{
  font-size: 16px;
}
/deep/.el-carousel__container{
  height: calc(64.6vw/4.18);
}
.tab{
  display: inline-block;
  border: 1px solid #59C264;
  border-radius: 12px;
  color: #59C264;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #F0FFF2;
}
.tab1{
  display: inline-block;
  border: 1px solid #EFA13E;
  border-radius: 12px;
  color: #EFA13E;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #FEF7EE;
}
.tab_first{
  border: 1px solid #EFA13E;
  border-radius: 12px;
  color: #EFA13E;
  min-width: 52px;
  font-size: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  line-height: 12px;
  text-align: center;
  margin-right: 7px;
  cursor: default;
  background-color: #FEF7EE;
}
.forum_title{
  line-height: 30px;
  font-size: 20px;
  margin-right: 15px;
  cursor: pointer;
  /*max-width: 310px;*/
  /*text-overflow: ellipsis;*/
  /*white-space: nowrap;*/
  word-break: break-all;
  color: black;
  text-decoration: none;
  /*overflow: hidden;*/
}
.forum_title:hover{
  color: #4D78FF;
  text-decoration:underline;
}
.forum_author{
  font-size: 14px;
  margin-right: 46px;
  display: flex;
}
.forum_author > forum_author_text {
  color: #2f374b;
}

.forum_time{
  font-size: 14px;
  color: #999999;
  letter-spacing: 2px
}

.flag_icon_container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 1px;
}

.flag_icon_container > .flag_icon_item {
  width: 0.85em;
}

.pagination{
  padding: 28px 0;
  text-align: right;
}
/deep/.el-pagination__total{
  font-size:12px;
  color: #999999;
}
/deep/.el-pagination__jump{
  font-size:12px;
  color: #999999;
}
.popover_body{
  height: 210px;width: 100%;padding: 16px 40px;box-sizing: border-box
}
.popover_head{
  padding: 0 90px;height: 90px;width: 100%;box-sizing: border-box;display: flex;align-items: center;
}
.popover_head > img {
  width: 88px;height: 88px;
}
.popover_foot {
  padding-top: 10px;
  display: flex;
  height: 80px;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}
.popover_foot > div{
  width: 33%;
}
.popover_message{
  padding-left: 27px;
}
.popover_message > div{
  font-size: 20px;
  color: #2F374B;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.popover_tab {
  border: 1px solid #4D78FF;
  font-size: 14px;
  line-height: 1;
  border-radius: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  color: #4D78FF;
  margin-left: 20px;
}
</style>
